export function sortRecordsByTestStarted(records, sortOrder) {
  return [...records].sort((a, b) => {
    const dateA = new Date(a.testStarted);
    const dateB = new Date(b.testStarted);
    return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
  });
}

export function getDatePreset(preset) {
  const date = new Date();
  if (preset === 'yesterday') date.setDate(date.getDate() - 1);
  if (preset === 'sevenDaysAgo') date.setDate(date.getDate() - 7);
  if (preset === 'thirtyDaysAgo') date.setDate(date.getDate() - 30);
  return date;
}
